import type { ImportantKpiEntry } from '@app/src/pages/Configurations/ConfigurationsPages/Automation/CreationSteps/HighlightImportantKpis/types'

export enum ExpectationAutomationFormField {
  Id = 'id',
  AssessmentTemplateId = 'assessmentTemplateId',
  TargetAssessmentLevel = 'targetAssessmentLevel',
  HighestAllowedProviderRiskStatus = 'highestAllowedProviderRiskStatus',
  DeadlineType = 'deadlineType',
  CustomDueDate = 'customDueDate',
  ImportantKpis = 'importantKpis',
  ApplyToExisting = 'applyToExisting',
}

export type DeadlineType = 1 | 2 | 3 | 'custom'

export enum SupplierRiskOption {
  Any = 'Any',
  Extreme = 'Extreme',
  HighOrExtreme = 'HighOrExtreme',
  MediumOrHigher = 'MediumOrHigher',
}

export type ExpectationAutomationFormData = {
  [ExpectationAutomationFormField.Id]?: number
  [ExpectationAutomationFormField.AssessmentTemplateId]: number | null
  [ExpectationAutomationFormField.TargetAssessmentLevel]: number
  [ExpectationAutomationFormField.HighestAllowedProviderRiskStatus]: SupplierRiskOption
  [ExpectationAutomationFormField.DeadlineType]: DeadlineType
  [ExpectationAutomationFormField.CustomDueDate]?: string | null
  [ExpectationAutomationFormField.ImportantKpis]: ImportantKpiEntry[]
  [ExpectationAutomationFormField.ApplyToExisting]?: boolean
}
